import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { BookOpen, Users, Briefcase, FileText, Calendar, Inbox, Images, MessageSquare, Handshake, HelpCircle, FileEdit, Eye, EyeOff, ArrowRight } from "lucide-react";

const CARDS = [
  { key: "books", label: "Livros", icon: BookOpen, to: "/admin/books" },
  { key: "authors", label: "Autores", icon: Users, to: "/admin/authors" },
  { key: "services", label: "Serviços", icon: Briefcase, to: "/admin/services" },
  { key: "blog_posts", label: "Artigos", icon: FileText, to: "/admin/blog" },
  { key: "events", label: "Eventos", icon: Calendar, to: "/admin/events" },
  { key: "submissions_new", label: "Mensagens novas", icon: Inbox, to: "/admin/submissions", accent: true },
  { key: "gallery", label: "Galeria", icon: Images, to: "/admin/gallery" },
  { key: "testimonials", label: "Depoimentos", icon: MessageSquare, to: "/admin/testimonials" },
  { key: "partners", label: "Parceiros", icon: Handshake, to: "/admin/partners" },
  { key: "faqs", label: "FAQs", icon: HelpCircle, to: "/admin/faqs" },
  { key: "pages_published", label: "Páginas publicadas", icon: Eye, to: "/admin/pages" },
  { key: "pages_under_construction", label: "Em construção", icon: EyeOff, to: "/admin/pages" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/submissions").then((r) => setSubs(r.data.slice(0, 5)));
  }, []);

  return (
    <div>
      <div className="mb-10">
        <h1 className="font-serif text-4xl text-[color:var(--marupiara-gold)] mb-1">Dashboard</h1>
        <p className="text-white/60">Visão geral do portal Marupiara</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
        {CARDS.map((c) => (
          <Link
            key={c.key}
            to={c.to}
            data-testid={`stat-card-${c.key}`}
            className={`p-5 border transition-colors ${c.accent ? "bg-[color:var(--marupiara-gold)]/10 border-[color:var(--marupiara-gold)]/40 hover:border-[color:var(--marupiara-gold)]" : "bg-[color:var(--marupiara-charcoal)] border-white/10 hover:border-[color:var(--marupiara-gold)]/40"}`}
          >
            <div className="flex items-center justify-between mb-4">
              <c.icon size={20} className="text-[color:var(--marupiara-gold)]" />
              <ArrowRight size={14} className="text-white/65" />
            </div>
            <div className="font-serif text-4xl text-white">{stats[c.key] ?? "—"}</div>
            <div className="text-xs uppercase tracking-wider text-white/60 mt-2">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="bg-[color:var(--marupiara-charcoal)] border border-white/10 p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-serif text-2xl text-[color:var(--marupiara-gold)]">Mensagens recentes</h3>
          <Link to="/admin/submissions" className="text-sm text-[color:var(--marupiara-gold)] hover:text-[color:var(--marupiara-gold-light)]">Ver todas</Link>
        </div>
        {subs.length === 0 ? (
          <p className="text-white/70 text-sm">Nenhuma mensagem por enquanto.</p>
        ) : (
          <ul className="divide-y divide-white/5">
            {subs.map((s) => (
              <li key={s.id} className="py-3 flex justify-between items-start gap-4">
                <div className="min-w-0">
                  <div className="text-white font-medium">{s.name} <span className="text-white/65 text-xs">— {s.email}</span></div>
                  <div className="text-white/60 text-sm truncate">{s.subject || s.form_type}: {s.message}</div>
                </div>
                <span className="text-[10px] uppercase tracking-wider text-white/65 shrink-0">{new Date(s.created_at).toLocaleDateString("pt-BR")}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
